import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.chat');
import { OnInit, ViewChild, ElementRef } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-chat',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.chat/view.scss */
@charset "UTF-8";
:host {
  display: block;
  height: 100%;
}

/* ─── Markdown Rendering ────────────────────────────── */
.chat-markdown h3, .chat-markdown h4, .chat-markdown h5, .chat-markdown h6 {
  font-weight: 600;
  margin-top: 1em;
  margin-bottom: 0.5em;
  color: #1c1917;
}
.chat-markdown h3:first-child, .chat-markdown h4:first-child, .chat-markdown h5:first-child, .chat-markdown h6:first-child {
  margin-top: 0;
}
.chat-markdown h3 {
  font-size: 15px;
}
.chat-markdown h4 {
  font-size: 14px;
}
.chat-markdown p {
  margin-bottom: 0.75em;
}
.chat-markdown p:last-child {
  margin-bottom: 0;
}
.chat-markdown ul, .chat-markdown ol {
  padding-left: 1.5em;
  margin-bottom: 0.75em;
}
.chat-markdown ul {
  list-style-type: disc;
}
.chat-markdown ol {
  list-style-type: decimal;
}
.chat-markdown li {
  margin-bottom: 0.25em;
}
.chat-markdown strong {
  font-weight: 600;
  color: #1c1917;
}
.chat-markdown em {
  font-style: italic;
}
.chat-markdown code {
  background: #e7e5e4;
  padding: 0.15em 0.4em;
  border-radius: 4px;
  font-size: 0.9em;
  font-family: "JetBrains Mono", ui-monospace, monospace;
}
.chat-markdown pre {
  background: #1c1917;
  color: #e7e5e4;
  padding: 12px 16px;
  border-radius: 8px;
  overflow-x: auto;
  margin-bottom: 0.75em;
  font-size: 12px;
  line-height: 1.5;
}
.chat-markdown pre code {
  background: transparent;
  padding: 0;
  border-radius: 0;
  color: inherit;
  font-size: inherit;
}
.chat-markdown blockquote {
  border-left: 3px solid #a8a29e;
  padding-left: 12px;
  margin: 0.75em 0;
  color: #78716c;
}
.chat-markdown table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 0.75em;
  font-size: 12px;
}
.chat-markdown table th, .chat-markdown table td {
  border: 1px solid #e7e5e4;
  padding: 6px 10px;
  text-align: left;
}
.chat-markdown table th {
  background: #f5f5f4;
  font-weight: 600;
}
.chat-markdown table tr:nth-child(even) {
  background: #fafaf9;
}
.chat-markdown a {
  color: #0284c7;
  text-decoration: underline;
  text-underline-offset: 2px;
}
.chat-markdown a:hover {
  color: #0369a1;
}
.chat-markdown hr {
  border: none;
  border-top: 1px solid #e7e5e4;
  margin: 1em 0;
}

/* Dark mode markdown */
:host-context(.dark) .chat-markdown h3, :host-context(.dark) .chat-markdown h4, :host-context(.dark) .chat-markdown h5, :host-context(.dark) .chat-markdown h6, :host-context(.dark) .chat-markdown strong,
.dark .chat-markdown h3,
.dark .chat-markdown h4,
.dark .chat-markdown h5,
.dark .chat-markdown h6,
.dark .chat-markdown strong {
  color: #e7e5e4;
}
:host-context(.dark) .chat-markdown code,
.dark .chat-markdown code {
  background: #292524;
}
:host-context(.dark) .chat-markdown pre,
.dark .chat-markdown pre {
  background: #1c1917;
  border: 1px solid #44403c;
}
:host-context(.dark) .chat-markdown blockquote,
.dark .chat-markdown blockquote {
  border-left-color: #57534e;
  color: #a8a29e;
}
:host-context(.dark) .chat-markdown table th, :host-context(.dark) .chat-markdown table td,
.dark .chat-markdown table th,
.dark .chat-markdown table td {
  border-color: #44403c;
}
:host-context(.dark) .chat-markdown table th,
.dark .chat-markdown table th {
  background: #292524;
}
:host-context(.dark) .chat-markdown table tr:nth-child(even),
.dark .chat-markdown table tr:nth-child(even) {
  background: #1c1917;
}
:host-context(.dark) .chat-markdown a,
.dark .chat-markdown a {
  color: #38bdf8;
}
:host-context(.dark) .chat-markdown a:hover,
.dark .chat-markdown a:hover {
  color: #7dd3fc;
}
:host-context(.dark) .chat-markdown hr,
.dark .chat-markdown hr {
  border-top-color: #44403c;
}

/* ─── Streaming Cursor ───────────────────────────────── */
.chat-markdown.streaming::after {
  content: "▋";
  display: inline;
  animation: blink 0.7s step-end infinite;
  color: #78716c;
  font-weight: 400;
  margin-left: 1px;
}

@keyframes blink {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}
/* ─── Typing Dots Animation ─────────────────────────── */
.typing-dots .dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #a8a29e;
  animation: dotBounce 1.4s ease-in-out infinite both;
}
.typing-dots .dot:nth-child(1) {
  animation-delay: 0s;
}
.typing-dots .dot:nth-child(2) {
  animation-delay: 0.2s;
}
.typing-dots .dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes dotBounce {
  0%, 80%, 100% {
    transform: scale(0.6);
    opacity: 0.4;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}
/* ─── Line Clamp ────────────────────────────────────── */
.line-clamp-4 {
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* ─── Score Bar Animation ───────────────────────────── */
.score-bar-fill {
  transition: width 0.6s ease;
}

/* ─── Scrollbar ─────────────────────────────────────── */
:host ::ng-deep .overflow-auto::-webkit-scrollbar {
  width: 4px;
}
:host ::ng-deep .overflow-auto::-webkit-scrollbar-track {
  background: transparent;
}
:host ::ng-deep .overflow-auto::-webkit-scrollbar-thumb {
  background: #d6d3d1;
  border-radius: 4px;
}
:host ::ng-deep .overflow-auto::-webkit-scrollbar-thumb:hover {
  background: #a8a29e;
}`],
})
export class PageChatComponent implements OnInit {
    @ViewChild('chatContainer') chatContainer: ElementRef;
    @ViewChild('inputArea') inputArea: ElementRef;

    public collections: any[] = [];
    public selectedScope: string = 'all';
    public messages: any[] = [];
    public inputText: string = '';
    public loading: boolean = true;
    public sending: boolean = false;
    public streamingContent: string = '';
    public showMobileScope: boolean = false;

    // Session management
    public chatSessions: any[] = [];
    public currentSessionId: string = '';
    public showSessionPanel: boolean = true;
    public renamingSessionId: string = '';
    public renameText: string = '';

    public exampleQuestions: string[] = [
        '이 자료함에서 가장 많이 언급된 지명은?',
        '두 문서의 공통 주제는 무엇인가요?',
        '이 문서의 핵심 내용을 요약해줘',
        '관련된 주요 인물을 정리해줘'
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        await this.loadCollections();
        await this.loadSessions();

        // URL ?q= 파라미터로 바로 질문 전송 (Graph → Chat 연동)
        const params = new URLSearchParams(window.location.search);
        const q = params.get('q');
        if (q) {
            window.history.replaceState({}, '', window.location.pathname);
            this.inputText = q;
            await this.sendMessage();
        }
    }

    public async loadCollections() {
        this.loading = true;
        await this.service.render();

        const { code, data } = await wiz.call("collections");
        if (code === 200) {
            this.collections = data.collections || [];
        }

        this.loading = false;
        await this.service.render();
    }

    public async loadSessions() {
        const { code, data } = await wiz.call("sessions");
        if (code === 200) {
            this.chatSessions = data.sessions || [];
        }
        if (this.chatSessions.length > 0 && !this.currentSessionId) {
            await this.selectSession(this.chatSessions[0].id);
        } else if (this.chatSessions.length === 0) {
            this.messages = [];
        }
        await this.service.render();
        this.scrollToBottom();
    }

    public async selectSession(sessionId: string) {
        if (this.currentSessionId === sessionId) return;
        this.currentSessionId = sessionId;
        this.messages = [];
        await this.service.render();

        const { code, data } = await wiz.call("history", { session_id: sessionId });
        if (code === 200) {
            this.messages = (data.messages || []).map((msg: any) => {
                if (msg.role === 'assistant' && msg.content) {
                    msg.html = this.renderMarkdown(msg.content);
                }
                return msg;
            });
        }
        await this.service.render();
        this.scrollToBottom();
    }

    public async newChat() {
        this.currentSessionId = '';
        this.messages = [];
        await this.service.render();
    }

    public async deleteSession(sessionId: string, event: Event) {
        event.stopPropagation();
        const res = await this.service.modal.show({
            title: '대화를 삭제하시겠습니까?',
            message: '이 대화의 모든 내용이 삭제됩니다.',
            action: '삭제',
            actionBtn: 'error'
        });
        if (!res) return;
        const { code } = await wiz.call("delete_session", { session_id: sessionId });
        if (code === 200) {
            this.chatSessions = this.chatSessions.filter(s => s.id !== sessionId);
            if (this.currentSessionId === sessionId) {
                this.currentSessionId = '';
                this.messages = [];
            }
        }
        await this.service.render();
    }

    public async startRename(session: any, event: Event) {
        event.stopPropagation();
        this.renamingSessionId = session.id;
        this.renameText = session.title;
        await this.service.render();
    }

    public async confirmRename(session: any) {
        if (!this.renameText.trim()) {
            this.renamingSessionId = '';
            return;
        }
        const { code } = await wiz.call("rename_session", { session_id: session.id, title: this.renameText.trim() });
        if (code === 200) {
            session.title = this.renameText.trim();
        }
        this.renamingSessionId = '';
        await this.service.render();
    }

    public async cancelRename() {
        this.renamingSessionId = '';
        await this.service.render();
    }

    public async exportSession() {
        if (!this.currentSessionId) return;
        const { code, data } = await wiz.call("export_session", { session_id: this.currentSessionId });
        if (code === 200) {
            const blob = new Blob([data.text], { type: 'text/markdown;charset=utf-8' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${data.title || '대화'}_${new Date().toISOString().slice(0, 10)}.md`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        }
    }

    public async selectScope(scope: string) {
        this.selectedScope = scope;
        this.showMobileScope = false;
        await this.service.render();
    }

    public toggleMobileScope() {
        this.showMobileScope = !this.showMobileScope;
    }

    public async useExample(question: string) {
        this.inputText = question;
        await this.sendMessage();
    }

    public async sendMessage() {
        if (!this.inputText.trim() || this.sending) return;

        const userMsg = {
            role: 'user',
            content: this.inputText.trim(),
            created: new Date().toISOString().slice(0, 16)
        };
        this.messages.push(userMsg);
        const query = this.inputText.trim();
        this.inputText = '';
        this.sending = true;
        this.streamingContent = '';

        if (this.inputArea) {
            this.inputArea.nativeElement.style.height = 'auto';
        }

        await this.service.render();
        this.scrollToBottom();

        try {
            await this.streamAsk(query);
        } catch (e) {
            console.error('[CHAT] streamAsk error:', e);
            this.messages.push({
                role: 'assistant',
                content: '오류가 발생했습니다. 다시 시도해주세요.',
                html: this.renderMarkdown('오류가 발생했습니다. 다시 시도해주세요.'),
                sources: [],
                created: new Date().toISOString().slice(0, 16)
            });
        }

        this.sending = false;
        this.streamingContent = '';
        await this.service.render();
        this.scrollToBottom();
    }

    private async streamAsk(query: string) {
        const formData = new FormData();
        formData.append('query', query);
        formData.append('scope', this.selectedScope);
        formData.append('session_id', this.currentSessionId);

        const url = '/wiz/api/page.chat/stream_ask';

        const response = await fetch(url, {
            method: 'POST',
            body: formData,
            credentials: 'same-origin'
        });

        if (!response.ok) {
            throw new Error('Stream request failed: ' + response.status);
        }

        const reader = response.body!.getReader();
        const decoder = new TextDecoder();
        let buffer = '';
        let sources: any[] = [];
        let fullContent = '';

        const assistantMsg: any = {
            role: 'assistant',
            content: '',
            html: '',
            sources: [],
            streaming: true,
            created: new Date().toISOString().slice(0, 16)
        };
        this.messages.push(assistantMsg);

        let lastRenderTime = 0;
        const RENDER_THROTTLE = 80;

        while (true) {
            const { done, value } = await reader.read();
            if (done) break;

            buffer += decoder.decode(value, { stream: true });
            const lines = buffer.split('\n\n');
            buffer = lines.pop() || '';

            for (const line of lines) {
                if (!line.startsWith('data: ')) continue;
                try {
                    const event = JSON.parse(line.slice(6));

                    if (event.type === 'sources') {
                        sources = event.sources || [];
                        assistantMsg.sources = sources;
                    } else if (event.type === 'session_id') {
                        if (event.session_id && !this.currentSessionId) {
                            this.currentSessionId = event.session_id;
                        }
                    } else if (event.type === 'token') {
                        fullContent += event.token;
                        assistantMsg.content = fullContent;
                        this.streamingContent = fullContent;
                    } else if (event.type === 'done') {
                        assistantMsg.streaming = false;
                        assistantMsg.content = fullContent;
                        assistantMsg.html = this.renderMarkdown(fullContent);
                    } else if (event.type === 'error') {
                        assistantMsg.streaming = false;
                        assistantMsg.content = event.message || '오류가 발생했습니다.';
                        assistantMsg.html = this.renderMarkdown(assistantMsg.content);
                    }

                    const now = Date.now();
                    if (now - lastRenderTime >= RENDER_THROTTLE) {
                        lastRenderTime = now;
                        await this.service.render();
                        this.scrollToBottom();
                    }
                } catch (e) {
                    console.warn('[CHAT] SSE parse error:', line, e);
                }
            }
        }

        // Final render with buffer flush
        if (buffer.startsWith('data: ')) {
            try {
                const event = JSON.parse(buffer.slice(6));
                if (event.type === 'token') {
                    fullContent += event.token;
                    assistantMsg.content = fullContent;
                } else if (event.type === 'done') {
                    assistantMsg.streaming = false;
                }
            } catch (e) { }
        }

        assistantMsg.streaming = false;
        if (!assistantMsg.content) {
            assistantMsg.content = '답변을 생성할 수 없습니다.';
        }
        assistantMsg.html = this.renderMarkdown(assistantMsg.content);

        await this.service.render();
        this.scrollToBottom();
        await this.loadSessions();
    }

    private renderMarkdown(text: string): string {
        if (!text) return '';
        let html = text
            .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
            .replace(/^### (.+)$/gm, '<h4>$1</h4>')
            .replace(/^## (.+)$/gm, '<h3>$1</h3>')
            .replace(/^# (.+)$/gm, '<h3>$1</h3>')
            .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
            .replace(/\*(.+?)\*/g, '<em>$1</em>')
            .replace(/`([^`]+)`/g, '<code>$1</code>')
            .replace(/^- (.+)$/gm, '<li>$1</li>')
            .replace(/^(\d+)\. (.+)$/gm, '<li>$2</li>');
        html = html.replace(/(<li>.*?<\/li>\n?)+/g, (match) => '<ul>' + match + '</ul>');
        html = html.replace(/\n/g, '<br>');
        return html;
    }

    public async clearChat() {
        if (!this.currentSessionId) return;
        const res = await this.service.modal.show({
            title: '대화를 초기화하시겠습니까?',
            message: '이 대화의 모든 내용이 삭제됩니다. 이 작업은 되돌릴 수 없습니다.',
            action: '초기화',
            actionBtn: 'error'
        });
        if (!res) return;
        const { code } = await wiz.call("clear_history", { session_id: this.currentSessionId });
        if (code === 200) {
            this.messages = [];
        }
        await this.service.render();
    }

    public async sendFeedback(msg: any, type: string) {
        if (!msg.id) return;
        const newFeedback = msg.feedback === type ? '' : type;
        const { code } = await wiz.call("feedback", { message_id: msg.id, feedback: newFeedback });
        if (code === 200) {
            msg.feedback = newFeedback;
        }
        await this.service.render();
    }

    public scrollToBottom() {
        setTimeout(() => {
            if (this.chatContainer) {
                const el = this.chatContainer.nativeElement;
                el.scrollTop = el.scrollHeight;
            }
        }, 50);
    }

    public autoResize() {
        if (!this.inputArea) return;
        const el = this.inputArea.nativeElement;
        el.style.height = 'auto';
        el.style.height = Math.min(el.scrollHeight, 150) + 'px';
    }

    public onKeydown(event: any) {
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            this.sendMessage();
        }
    }

    public getCollectionTitle(id: string) {
        const col = this.collections.find((c: any) => c.id === id);
        return col ? col.title : id;
    }

    public getScopeLabel(): string {
        if (this.selectedScope === 'all') return '전체 자료';
        return this.getCollectionTitle(this.selectedScope);
    }

    public getCurrentSessionTitle(): string {
        const s = this.chatSessions.find(ss => ss.id === this.currentSessionId);
        return s ? s.title : '새 대화';
    }
}

export default PageChatComponent;